import { useLayoutEffect } from 'react';

interface ResetModuleWrapperStylesParams {
  isActive?: boolean;
}

export const useResetModuleWrapperStyles = ({
  isActive = true,
}: ResetModuleWrapperStylesParams = {}) => {
  useLayoutEffect(() => {
    const moduleWrapperEl = document.querySelector<HTMLDivElement>('.module-wrapper');

    if (moduleWrapperEl && isActive) {
      moduleWrapperEl.style.maxWidth = 'revert';
      moduleWrapperEl.style.padding = 'revert';
    }

    return () => {
      if (moduleWrapperEl && isActive) {
        moduleWrapperEl.style.maxWidth = '1200px';
        moduleWrapperEl.style.padding = '32px';
      }
    };
  }, [isActive]);
};
